import { Component, OnInit, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { CroppedImage } from 'src/app/_models/Common/croped-image';
import { CompressImageService } from 'src/app/_services/compress-image.service';
import { CropAndCompressImageDialogComponent } from '../crop-and-compress-image-dialog/crop-and-compress-image-dialog.component';

@Component({
  selector: 'app-photo-gallery',
  templateUrl: './photo-gallery.component.html',
  styleUrls: ['./photo-gallery.component.scss']
})

export class PhotoGalleryComponent implements OnInit {
  maxSize : number=3000000;  //3 MB = 3000000 Bytes (in decimal)
  pictureFormat : Array<string>;
  // pictureIsToBig : boolean = false;
  pictureIsWrongFormat : boolean = false;
  @Input() populatedImages = new Array<string>(12)
  @Input() hasBeenEdited:boolean = false
  
  @Output() imageEvent = new EventEmitter<any[]>();
  // public images = new Array<string>(12);
  public imagesServerData = new Array<photoModel>(12);

  constructor(
    private openFile:ElementRef,
    private compressImage: CompressImageService,
    public dialogService: DialogService,
    public translate: TranslateService,
  ) {
    this.pictureFormat = ['image/png','image/jpg','image/jpeg'];
    for(let i = 0; i < 12; i++) {
      this.imagesServerData[i] = new photoModel()
    }
   }

  ngOnInit(): void {
    if(this.hasBeenEdited) {
     let i=0
      this.populatedImages.forEach(item =>{        
        this.imagesServerData[i].url = item;
        i++
      })
      // this.images = this.populatedImages
    }
  }

  openAddImage(index: number) {
    var element = this.openFile.nativeElement.querySelector(`#openPhoto-${index}`);
    element.click();
  }

  removeImage(index: number) {    
    this.imagesServerData[index] = new photoModel();
    this.imageEvent.emit(this.imagesServerData)
  }

  cropAndCompressImageDialog(index: number) {
    const ref = this.dialogService.open(CropAndCompressImageDialogComponent, {
      data: {
        imagePath: this.imagesServerData[index].url,
      },
      autoZIndex: true,
      header: this.translate.instant('PREVIEW'),
      width: '960px',
      contentStyle: { "overflow-y": "auto" },
    });
    ref.onClose.subscribe((image: CroppedImage) => {
      if (image) {
        this.imagesServerData[index].url = image.imagePath;
        this.imagesServerData[index].file = image.imageFile;
        this.imageEvent.emit(this.imagesServerData);
      }
    });
  }

  onFileSelected(event: any, index: number) {    
    // this.pictureIsToBig = false;
    this.pictureIsWrongFormat=false;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
    
      if(!this.pictureFormat.includes( event.target.files[0].type)){
        this.pictureIsWrongFormat = true;
        return
      }
      let image: File = event.target.files[0]    
      reader.readAsDataURL(image);// read file as data url
      this.compressImage.compress(image)
        .pipe(take(1))
        .subscribe(compressedImage => {          
          this.imagesServerData[index].file = compressedImage
          this.imageEvent.emit(this.imagesServerData)
        })
     
      reader.onload = (item) => { // called once readAsDataURL is completed
        if(item.target?.result) {
          // @ts-ignore
          this.imagesServerData[index].url = item.target?.result
        }
      }
    }
  }
}

export class photoModel {
  url :string="";
  file:any;
}
